import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import apiRoutes from '../api/apiRoutes';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState(null);
  const [institutions, setInstitutions] = useState([]);
  const [qlikRoles, setQlikRoles] = useState([]);
  const [parentApps, setParentApps] = useState([]);
  const [permissionsData, setPermissions] = useState({}); // Guardar permisos en el estado

  // Función para obtener los datos de un usuario
  const getUserData = async (oktaId) => {
    try {
      const response = await axios.post(apiRoutes.user.datauser, {
        oktaid: oktaId,
      });
      setUserData(response.data.data);
      return response.data.data;
    } catch (err) {
      setError(err);
      return err;
    }
  };

  // Función para obtener todos los usuarios (paginado y con búsqueda)
  const getUserDataViewas = async (oktaId) => {
    try {
      const response = await axios.post(apiRoutes.user.datauser, {
        oktaid: oktaId,
      });
      
      return response.data.data;
  
    } catch (err) {
      return err
    }
  }
  const getAllUserData = async (page = 1, searchTerm = '') => {
    try {
      const response = await axios.get(`${apiRoutes.user.datauser}?page=${page}&limit=10&searchTerm=${searchTerm}`);
      return response.data;
    } catch (err) {
      setError(err);
      return err;
    }
  };
  // Función para actualizar la configuración del usuario
  const updateSettings = async (name, value) => {
    try {
      const response = await axios.post(`${apiRoutes.user.updateSettings}`, {
        name,  // El nombre del setting que deseas actualizar
        value, // El nuevo valor para la columna "value"
      });
      return response.data;
    } catch (err) {
      console.error('Error updating settings:', err.response ? err.response.data : err.message);
      setError(err);
      throw err;
    }
  };
  
    // Función para obtener todas las configuraciones
    const getAllSettings = async () => {
      try {
        const response = await axios.get(apiRoutes.user.settings); // Ajusta la ruta según tu estructura
        return response.data.data;
      } catch (err) {
        console.error('Error fetching settings:', err.response ? err.response.data : err.message);
        setError(err);
        throw err;
      }
    };

  // Función para obtener las instituciones desde la API
  const getInstitutions = async () => {
    try {
      const response = await axios.get(apiRoutes.permissions.getInstitutions);
      setInstitutions(response.data.data);
    } catch (err) {
      setError(err);
    }
  };

  // Función para obtener los Qlik Roles desde la API
  const getQlikRoles = async () => {
    try {
      const response = await axios.get(apiRoutes.permissions.getQlikRoles);
      setQlikRoles(response.data.data);
    } catch (err) {
      setError(err);
    }
  };

  // Función para obtener los Parent Apps desde la API
  const getParentApps = async () => {
    try {
      const response = await axios.get(apiRoutes.permissions.getParentApps);
      setParentApps(response.data.data);
    } catch (err) {
      setError(err);
    }
  };

  // Función para obtener los permisos desde la API
  const getPermissions = async () => {
    try {
      const response = await axios.get(apiRoutes.permissions.createPermissions);  // Agrega la ruta del endpoint correcto aquí
      setPermissions(response.data.data);  // Almacenar los permisos en el estado
    } catch (err) {
      setError(err);
    }
  };

  // Función para actualizar los permisos
  const updatePermissions = async (permissionsData) => {
    try {
      const response = await axios.post(apiRoutes.permissions.createPermissions, permissionsData);
      if (response.data.success) {
        return response.data;
      } else {
        console.error("Error al actualizar permisos");
        throw new Error("Error al actualizar permisos");
      }
    } catch (error) {
      console.error("Error al actualizar los permisos:", error);
      throw error;
    }
  };



  return (
    <UserContext.Provider
      value={{
        getUserData,
        userData,
        getAllUserData,
        updateSettings,
        getAllSettings,
        getUserDataViewas,
        updatePermissions,
        getPermissions,
        permissionsData,
        getInstitutions,
        getQlikRoles,
        getParentApps,
        institutions,
        qlikRoles,
        parentApps,
        error
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
